/**
 * Emergency detector for the Evie widget. Pure and dependency-free, like sentiment.ts.
 *
 * A hit changes the whole turn: Evie's first reply gives two ways to reach a person right now and a
 * Highest-priority ticket is filed. So only explicit signals count: the words "urgent" or "emergency",
 * "asap"/"immediately", a demand for help now, or a patient waiting in the chair.
 */

export const URGENCY_PATTERNS: RegExp[] = [
  /\b(urgent(ly)?|emergency|emergencies)\b/i,
  /\b(asap|right away|straight away|immediately|time[- ]critical|life[- ]threatening)\b/i,
  /\b(need|want|get me|send)\b.{0,30}\b(someone|somebody|a person|help|support)\b.{0,20}\b(now|right now|today|immediately)\b/i,
  /\b(patient|pt)\b.{0,30}\b(in the chair|here now|waiting (here|now)|in pain|bleeding)\b/i,
];

/** "not urgent", "no emergency", "isn't an emergency": the word is there but the meaning is the opposite. */
export const NEGATED_URGENCY = /\b(not|no|isn't|is not|nothing|non)[\s-]+(an?\s+|really\s+|that\s+)?(urgent|emergency|emergencies)\b/i;

export function isUrgent(text: string | null | undefined): boolean {
  const raw = String(text ?? '').trim();
  if (!raw) return false;
  if (NEGATED_URGENCY.test(raw)) return false;
  return URGENCY_PATTERNS.some((re) => re.test(raw));
}
